/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RtSystemManufacturer = {
    MsAbCt: 'MS_AB_CT',
    MsAccuray: 'MS_Accuray',
    MsAkesis: 'MS_Akesis',
    MsArianeMedicalSystems: 'MS_ArianeMedicalSystems',
    MsBestTheratronics: 'MS_BestTheratronics',
    MsBrainlab: 'MS_Brainlab',
    MsCanon: 'MS_Canon',
    MsCefla: 'MS_Cefla',
    MsDosisoft: 'MS_Dosisoft',
    MsEckertZiegler: 'MS_EckertZiegler',
    MsElekta: 'MS_Elekta',
    MsFujifilm: 'MS_Fujifilm',
    MsGe: 'MS_GE',
    MsHitachi: 'MS_Hitachi',
    MsIba: 'MS_Iba',
    MsIntraOp: 'MS_IntraOp',
    MsLeksell: 'MS_Leksell',
    MsMdsNordion: 'MS_MDSNordion',
    MsMinFound: 'MS_MinFound',
    MsPanaceaMedicalTechnologies: 'MS_PanaceaMedicalTechnologies',
    MsPhilips: 'MS_Philips',
    MsProwess: 'MS_Prowess',
    MsRaySearch: 'MS_RaySearch',
    MsSensus: 'MS_Sensus',
    MsSiemens: 'MS_Siemens',
    MsSiemensHealthineers: 'MS_SiemensHealthineers',
    MsSit: 'MS_SIT',
    MsToshiba: 'MS_Toshiba',
    MsUjp: 'MS_UJP',
    MsVarian: 'MS_Varian',
    MsViewRay: 'MS_ViewRay',
    MsXcision: 'MS_Xcision',
    MsXstrahl: 'MS_Xstrahl',
    MsZapSurgicalSystems: 'MS_ZapSurgicalSystems',
    MsZeiss: 'MS_Zeiss',
    MsOther: 'MS_Other',
    PtwFreiburg: 'PTW_Freiburg'
} as const;
export type RtSystemManufacturer = typeof RtSystemManufacturer[keyof typeof RtSystemManufacturer];


export function RtSystemManufacturerFromJSON(json: any): RtSystemManufacturer {
    return RtSystemManufacturerFromJSONTyped(json, false);
}

export function RtSystemManufacturerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RtSystemManufacturer {
    return json as RtSystemManufacturer;
}

export function RtSystemManufacturerToJSON(value?: RtSystemManufacturer | null): any {
    return value as any;
}

/**
 * Check if a given object implements the RtSystemManufacturer interface.
 */
 export function instanceOfRtSystemManufacturer(value: any): value is RtSystemManufacturer {
    return Object.values(RtSystemManufacturer).includes(value)
}

